import { compose, propEq, find } from 'ramda'

export const getUpgradePopupCTAUpgrade = compose(
  option => option.value,
  find(propEq('key', 'BASIC_SUBS_POPUP_CTA_UPGRADE'))
)
